<div class="overflow-auto w-full h-full pb-20 bg-gray-50 font-prompt mx-auto">
  <div
    class="w-full bg-(--header-background) px-4 py-3 flex items-center justify-between sticky top-0 z-30 shadow-sm text-white select-none">
    <button type="button" (click)="goBack()"
      class="flex items-center text-white hover:opacity-80 active:scale-95 transition-all outline-none border-0 bg-transparent p-0 cursor-pointer">
      <img src="icons/arrow_back_white.svg" alt="back" />
    </button>
    <h1 class="text-sm font-bold tracking-wide m-0">
      {{ currentLang === 'TH' ? 'รายละเอียดลานจอด' : 'Parking site' }}
    </h1>
    <div class="w-6"></div>
  </div>

  <div *ngIf="notFound && !isLoading" class="px-4 pt-10 text-center">
    <p class="text-sm font-bold text-slate-700">
      {{ currentLang === 'TH' ? 'ไม่พบข้อมูลลานจอด' : 'Parking site not found' }}
    </p>
    <button type="button" (click)="goBack()"
      class="mt-4 px-4 py-2 rounded-xl bg-amber-400 text-slate-900 text-xs font-bold border-0 cursor-pointer">
      {{ currentLang === 'TH' ? 'กลับ' : 'Back' }}
    </button>
  </div>

  <div *ngIf="detail as d" class="pb-6">
    <div *ngIf="heroImages.length" class="relative">
      <div class="hero-rail flex overflow-x-auto snap-x snap-mandatory" (scroll)="onHeroScroll($event)">
        <button *ngFor="let url of heroImages; let i = index; trackBy: trackByUrl" type="button"
          (click)="openZoom(url)"
          class="zoom-media w-full h-56 flex-shrink-0 snap-center bg-slate-100 overflow-hidden border-0 p-0 cursor-zoom-in relative">
          <img [src]="url" [alt]="title" class="w-full h-full object-cover" [attr.loading]="i === 0 ? 'eager' : 'lazy'" />
        </button>
      </div>
      <div class="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/40 to-transparent pointer-events-none"></div>
      <span *ngIf="heroImages.length > 1"
        class="absolute bottom-3 right-3 px-2 py-0.5 rounded-full bg-black/55 text-white text-[10px] font-bold tabular-nums pointer-events-none">
        {{ heroIndex + 1 }}/{{ heroImages.length }}
      </span>
      <div *ngIf="heroImages.length > 1" class="absolute bottom-3.5 left-0 right-0 flex justify-center gap-1 pointer-events-none">
        <span *ngFor="let url of heroImages; let i = index; trackBy: trackByUrl"
          class="h-1.5 rounded-full transition-all"
          [ngClass]="heroIndex === i ? 'w-4 bg-amber-400' : 'w-1.5 bg-white/60'"></span>
      </div>
    </div>
    <div *ngIf="!heroImages.length" class="w-full h-32 bg-slate-200 flex items-center justify-center">
      <img src="/icons/marker-home.png" alt="" class="w-10 h-10 opacity-40" />
    </div>

    <div class="px-4 pt-4 space-y-3">
      <div class="flex items-center gap-2 flex-wrap">
        <span *ngIf="d.siteIsOnline"
          class="px-2 py-0.5 rounded-full bg-emerald-500 text-white text-[10px] font-bold">
          {{ currentLang === 'TH' ? 'เปิดแล้ว' : 'Open' }}
        </span>
      </div>

      <h2 class="text-base font-extrabold text-slate-800 leading-snug">{{ title }}</h2>
      <p *ngIf="address" class="text-xs text-slate-500 leading-relaxed">{{ address }}</p>
      <p *ngIf="summary" class="text-sm text-slate-600 leading-relaxed">{{ summary }}</p>

      <div *ngIf="d.amenities.length" class="pt-3">
        <h3 class="text-xs font-extrabold text-gray-500 uppercase tracking-wide mb-3 pl-2 border-l-4 border-amber-500">
          {{ currentLang === 'TH' ? 'มั่นใจทุกการจอด' : 'Park with confidence' }}
        </h3>
        <app-site-amenities [amenities]="d.amenities" [lang]="currentLang" variant="grid"></app-site-amenities>
      </div>

      <div *ngIf="galleryTabs.length" class="pt-3">
        <h3 class="text-xs font-extrabold text-gray-500 uppercase tracking-wide mb-3 pl-2 border-l-4 border-amber-500">
          {{ currentLang === 'TH' ? 'รูปภาพลานจอด' : 'Photos' }}
        </h3>
        <div *ngIf="galleryTabs.length > 1" class="flex gap-1.5 overflow-x-auto pb-2 -mx-4 px-4">
          <button *ngFor="let tab of galleryTabs; trackBy: trackByTab" type="button"
            (click)="selectGalleryCategory(tab.category)"
            class="flex-shrink-0 px-3 py-1.5 rounded-full text-[11px] font-bold border cursor-pointer transition-colors"
            [ngClass]="activeGalleryCategory === tab.category
              ? 'bg-slate-800 border-slate-800 text-white'
              : 'bg-white border-gray-200 text-slate-600'">
            {{ galleryCategoryLabel(tab.category) }} · {{ tab.images.length }}
          </button>
        </div>
        <div class="grid grid-cols-3 gap-1.5">
          <button *ngFor="let img of activeGalleryImages; trackBy: trackByImage" type="button"
            (click)="openZoom(img.image)"
            class="relative aspect-square rounded-xl overflow-hidden bg-slate-100 border-0 p-0 cursor-zoom-in">
            <img [src]="img.image" [alt]="imageCaption(img) || title" loading="lazy" class="w-full h-full object-cover" />
            <span *ngIf="imageCaption(img)"
              class="absolute inset-x-0 bottom-0 px-1.5 py-1 bg-gradient-to-t from-black/70 to-transparent text-[9px] font-semibold text-white text-left truncate">
              {{ imageCaption(img) }}
            </span>
          </button>
        </div>
      </div>

      <ng-container *ngFor="let group of sectionGroups; trackBy: trackByGroup">
        <div class="pt-3">
          <h3 class="text-xs font-extrabold text-gray-500 uppercase tracking-wide mb-3 pl-2 border-l-4 border-amber-500">
            {{ sectionLabel(group.section) }}
          </h3>
          <div class="space-y-3">
            <ng-container *ngFor="let block of group.blocks; trackBy: trackByBlock">
              <div *ngIf="block.blockType === 'image' && block.image"
                class="rounded-2xl overflow-hidden border border-gray-100 bg-white shadow-sm">
                <button type="button" (click)="openZoom(block.image)"
                  class="zoom-media w-full border-0 p-0 cursor-zoom-in bg-transparent relative">
                  <img [src]="block.image" [alt]="blockTitle(block) || title"
                    class="w-full max-h-64 object-cover" />
                  <span class="zoom-hint" aria-hidden="true">
                    <img src="icons/search_slate.svg" alt="" class="w-3.5 h-3.5 invert" />
                  </span>
                </button>
                <div *ngIf="blockTitle(block) || blockBody(block)" class="p-3 text-left">
                  <h4 *ngIf="blockTitle(block)" class="text-sm font-bold text-slate-800">{{ blockTitle(block) }}</h4>
                  <p *ngIf="blockBody(block)" class="text-xs text-slate-600 mt-1 whitespace-pre-wrap">{{ blockBody(block) }}</p>
                </div>
              </div>

              <div *ngIf="block.blockType !== 'image'"
                class="rounded-2xl bg-white border border-gray-100 shadow-sm p-3 text-left">
                <h4 *ngIf="blockTitle(block)" class="text-sm font-bold text-slate-800 mb-1">{{ blockTitle(block) }}</h4>
                <p *ngIf="blockBody(block)" class="text-sm text-slate-700 whitespace-pre-wrap leading-relaxed">
                  {{ blockBody(block) }}
                </p>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <div *ngIf="siteNews.length" class="pt-3">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-xs font-extrabold text-gray-500 uppercase tracking-wide pl-2 border-l-4 border-amber-500 m-0">
            {{ currentLang === 'TH' ? 'ประกาศจากลานนี้' : 'News from this lot' }}
          </h3>
          <button *ngIf="siteNewsTotal > siteNews.length" type="button" (click)="openAllSiteNews()"
            class="text-[11px] font-bold text-amber-600 bg-transparent border-0 p-0 cursor-pointer">
            {{ currentLang === 'TH' ? 'ดูทั้งหมด' : 'View all' }} ({{ siteNewsTotal }})
          </button>
        </div>
        <div class="flex gap-3 overflow-x-auto pb-1 -mx-4 px-4 snap-x">
          <button *ngFor="let news of siteNews; trackBy: trackByNews" type="button" (click)="openNews(news.id)"
            class="w-60 flex-shrink-0 snap-start text-left bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm active:scale-[0.99] transition-all cursor-pointer p-0">
            <div class="w-full h-28 bg-slate-100 overflow-hidden relative">
              <img *ngIf="news.coverImageUrl" [src]="news.coverImageUrl" [alt]="newsTitle(news)" loading="lazy"
                class="w-full h-full object-cover" />
              <div *ngIf="!news.coverImageUrl" class="w-full h-full flex items-center justify-center bg-amber-50">
                <img src="icons/notifications_orange.svg" alt="" class="w-7 h-7 opacity-50" />
              </div>
              <span *ngIf="news.pin"
                class="absolute top-2 left-2 px-2 py-0.5 rounded-lg bg-amber-400/95 text-[10px] font-bold text-slate-900">
                {{ currentLang === 'TH' ? 'ปักหมุด' : 'Pinned' }}
              </span>
            </div>
            <div class="p-3">
              <span *ngIf="news.categoryName"
                class="inline-block mb-1 px-1.5 py-0.5 rounded bg-slate-100 text-slate-600 text-[9px] font-bold">
                {{ news.categoryName }}
              </span>
              <h4 class="text-sm font-bold text-slate-800 line-clamp-2 m-0">{{ newsTitle(news) }}</h4>
              <p *ngIf="news.summary" class="text-xs text-slate-500 mt-1 line-clamp-2 m-0">{{ news.summary }}</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-image-viewer *ngIf="isViewerOpen" [images]="viewerImages" [startIndex]="viewerIndex"
  [lang]="currentLang" (closed)="closeZoom()"></app-image-viewer>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>
